import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["placeholder", "disabled"];
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = ["placeholder", "disabled"];
import { ref, computed } from '../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
// dayjs extension
import dayjs, { Dayjs } from 'dayjs';
import localeData from 'dayjs/plugin/localeData.js';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js';
import 'dayjs/locale/zh-cn';
import DatePickerPanel from './date-picker-panel.vue';
import { isPC, isUniFrameWork } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    type: {
      type: String,
      default: 'range' // "single":单选, 暂不支持 / "range":区间选择
    },
    rangeTableType: {
      type: String,
      default: 'one' // "one": 在 一个 datePanel 之内选择区间（注意，移动端因屏幕较窄，仅支持在一个 datePanel 中进行选择） / "two": 在 两个 datePanel 之间选择区间
    },
    startPlaceholder: {
      type: String,
      default: () => TUITranslateService.t('开始时间')
    },
    endPlaceholder: {
      type: String,
      default: () => TUITranslateService.t('开始时间')
    },
    popupPosition: {
      type: String,
      default: 'bottom' // "top": 向上弹出 datePanel / "bottom": 向下弹出 datePanel
    },
    // 默认单选日期
    defaultSingleDate: {
      type: Dayjs,
      default: null,
      required: false
    }
  },
  emits: ['pick', 'change'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    dayjs.extend(localeData);
    dayjs.extend(isSameOrAfter);
    dayjs.extend(isSameOrBefore);
    dayjs.locale('zh-cn');
    var emit = __emit;
    var props = __props;
    var isDatePanelShow = ref(false);
    var dateValue = ref(props.type === 'single' ? props === null || props === void 0 ? void 0 : props.defaultSingleDate : null);
    var startValue = ref(props.type === 'single' ? props === null || props === void 0 ? void 0 : props.defaultSingleDate : null);
    var endValue = ref(props.type === 'single' ? props === null || props === void 0 ? void 0 : props.defaultSingleDate : null);
    var startFormatDate = computed(() => {
      var _startValue$value;
      return startValue === null || startValue === void 0 || (_startValue$value = startValue.value) === null || _startValue$value === void 0 ? void 0 : _startValue$value.format('YYYY/MM/DD');
    });
    var endFormatDate = computed(() => {
      var _endValue$value;
      return endValue === null || endValue === void 0 || (_endValue$value = endValue.value) === null || _endValue$value === void 0 ? void 0 : _endValue$value.format('YYYY/MM/DD');
    });
    var startPlaceholderVal = props.startPlaceholder;
    var endPlaceholderVal = props.endPlaceholder;
    var leftCurrentPanelValue = ref();
    var rightCurrentPanelValue = ref();
    var setDatePanelDisplay = show => {
      isDatePanelShow.value = show;
    };
    var n = classNameList => {
      var resultClassList = [];
      classNameList.forEach(className => {
        if (className) {
          resultClassList.push('tui-date-picker-' + className);
          !isPC && resultClassList.push('tui-date-picker-h5-' + className);
        } else {
          resultClassList.push('tui-date-picker');
          !isPC && resultClassList.push('tui-date-picker-h5');
        }
      });
      return resultClassList;
    };
    var handlePick = cell => {
      switch (props.type) {
        case 'single':
          startValue.value = cell.date;
          endValue.value = cell.date;
          dateValue.value = cell.date;
          emit('change', cell);
          emit('pick', dateValue.value);
          // 避免生硬直接关闭
          setTimeout(() => {
            setDatePanelDisplay(false);
          }, 300);
          break;
        case 'range':
          if (!(startValue !== null && startValue !== void 0 && startValue.value)) {
            startValue.value = cell.date;
          } else if (!(endValue !== null && endValue !== void 0 && endValue.value)) {
            var _startValue$value2, _startValue$value3, _endValue$value2;
            if (startValue !== null && startValue !== void 0 && (_startValue$value2 = startValue.value) !== null && _startValue$value2 !== void 0 && _startValue$value2.isSameOrBefore(cell.date, 'day')) {
              endValue.value = cell.date;
            } else {
              endValue.value = startValue.value;
              startValue.value = cell.date;
            }
            emit('pick', {
              startDate: startValue === null || startValue === void 0 || (_startValue$value3 = startValue.value) === null || _startValue$value3 === void 0 ? void 0 : _startValue$value3.startOf('date'),
              endDate: endValue === null || endValue === void 0 || (_endValue$value2 = endValue.value) === null || _endValue$value2 === void 0 ? void 0 : _endValue$value2.endOf('date')
            });
            // 避免生硬直接关闭
            setTimeout(() => {
              setDatePanelDisplay(false);
            }, 200);
          } else {
            startValue.value = cell.date;
            endValue.value = null;
          }
          emit('change', {
            startDate: startValue.value,
            endDate: endValue.value,
            leftCurrentPanel: leftCurrentPanelValue.value,
            rightCurrentPanel: leftCurrentPanelValue.value
          });
          break;
      }
    };
    var handleLeftPanelChange = value => {
      leftCurrentPanelValue.value = value;
      emit('change', {
        startDate: startValue.value,
        endDate: endValue.value,
        leftCurrentPanel: leftCurrentPanelValue.value,
        rightCurrentPanel: leftCurrentPanelValue.value
      });
    };
    var handleRightPanelChange = value => {
      rightCurrentPanelValue.value = value;
      emit('change', {
        startDate: startValue.value,
        endDate: endValue.value,
        leftCurrentPanel: leftCurrentPanelValue.value,
        rightCurrentPanel: leftCurrentPanelValue.value
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([n([''])])
      }, [_createElementVNode("div", {
        class: _normalizeClass([n(['input']), _unref(isDatePanelShow) && n(['input-active'])]),
        onClick: _cache[2] || (_cache[2] = $event => setDatePanelDisplay(!_unref(isDatePanelShow)))
      }, [_renderSlot(_ctx.$slots, "start-icon"), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(startFormatDate) ? startFormatDate.value = $event : null),
        placeholder: _unref(startPlaceholderVal),
        class: _normalizeClass([n(['input-start'])]),
        style: {
          "pointer-events": "none"
        },
        type: "text",
        readonly: true,
        disabled: _unref(isUniFrameWork),
        autocomplete: "false"
      }, null, 10, _hoisted_1), [[_vModelText, _unref(startFormatDate)]]), __props.type !== 'single' ? (_openBlock(), _createElementBlock("span", _hoisted_2, "-")) : _createCommentVNode("", true), __props.type !== 'single' ? _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(endFormatDate) ? endFormatDate.value = $event : null),
        placeholder: _unref(endPlaceholderVal),
        class: _normalizeClass([n(['input-end'])]),
        style: {
          "pointer-events": "none"
        },
        type: "text",
        readonly: true,
        disabled: _unref(isUniFrameWork),
        autocomplete: "false"
      }, null, 10, _hoisted_3)), [[_vModelText, _unref(endFormatDate)]]) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "end-icon")], 2), _unref(isDatePanelShow) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([n(['dialog'])])
      }, [_createElementVNode("div", {
        class: _normalizeClass([n(['dialog-container', 'dialog-container-' + __props.rangeTableType, 'dialog-container-' + __props.popupPosition])])
      }, [_createVNode(DatePickerPanel, {
        type: props.type,
        rangeType: "left",
        date: _unref(dateValue),
        startDate: _unref(startValue),
        endDate: _unref(endValue),
        currentOtherPanelValue: _unref(rightCurrentPanelValue),
        onPick: handlePick,
        onChange: handleLeftPanelChange
      }, null, 8, ["type", "date", "startDate", "endDate", "currentOtherPanelValue"]), props.type === 'range' && _unref(isPC) && __props.rangeTableType === 'two' ? (_openBlock(), _createBlock(DatePickerPanel, {
        key: 0,
        type: props.type,
        rangeType: "right",
        date: _unref(dateValue),
        startDate: _unref(startValue),
        endDate: _unref(endValue),
        currentOtherPanelValue: _unref(leftCurrentPanelValue),
        onPick: handlePick,
        onChange: handleRightPanelChange
      }, null, 8, ["type", "date", "startDate", "endDate", "currentOtherPanelValue"])) : _createCommentVNode("", true)], 2)], 2)) : _createCommentVNode("", true)], 2);
    };
  }
});